<!-- eslint-disable @angular-eslint/template/elements-content -->
<button
    mat-icon-button
    [disableRipple]="true"
    [routerLink]="[redirectURL]"
    [style.background-image]="getBackgroundImageUrl()"
    class="logo"
    [style.width]="width"
    [style.height]="height"
></button>
